__turbopack_context__.v({
  "Active": "Timeline-module-sass-module__XcFzka__Active",
  "Cont": "Timeline-module-sass-module__XcFzka__Cont",
  "Main": "Timeline-module-sass-module__XcFzka__Main",
  "MainOuter": "Timeline-module-sass-module__XcFzka__MainOuter",
  "Slider": "Timeline-module-sass-module__XcFzka__Slider",
  "Timeline": "Timeline-module-sass-module__XcFzka__Timeline",
  "Year": "Timeline-module-sass-module__XcFzka__Year",
  "Years": "Timeline-module-sass-module__XcFzka__Years",
});
